import { useDomainAccessControl } from './utils/domain/accessControl'
import {
  adminStorefrontSetupViewAccessControl,
  onboardingSiteSetupChecklistAccessControl,
} from './access-control/onboardingAccess.configuration.ts'

export { usePendingPartnerOnboardingRedirection } from './utils/usePendingPartnerOnboardingRedirection.hooks'
export { useHideNavbarDueToPendingOnboarding } from './utils/useHideNavbarDueToPendingOnboarding.hooks'
export { OnboardingSiteSetupChecklistGroup } from './components/site-setup-checklist-group/OnboardingSiteSetupChecklistGroup'

// Export types and utils for whitelabel site workflow
export { WhitelabelSiteWorkflowState } from './components/utils/Onboarding.types'
export type { WhitelabelSiteData } from './components/utils/Onboarding.types'
export { useGetWhitelabelSiteStateLabelMap } from './utils/constants/OnboardingSiteSetup.constants'

// This is to check whether we should display the site setup checklist for a retailer/warehouse/banner
export const useHasSiteSetupChecklistAccess = () =>
  useDomainAccessControl()(onboardingSiteSetupChecklistAccessControl)

// This is to check whether the site setup features should be visible to the IPP user
export const useHasSiteSetupAccess = () =>
  useDomainAccessControl()(adminStorefrontSetupViewAccessControl)
